/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
import { wasCreatedByNewInfo } from '../../utils/gallery';
import { optionsMap, GALLERY_CONSTS } from 'pro-gallery-lib';
import '../../assets/styles/overlayHoverAnimations.scss';
export const WixProGalleryStylableOverlayAnimations = WixProGallery => props => {
  const shouldUseNewInfo = wasCreatedByNewInfo(props.options);
  const animationType = props.options[optionsMap.behaviourParams.item.overlay.hoverAnimation];
  if (!shouldUseNewInfo || animationType === GALLERY_CONSTS.behaviourParams_item_overlay_hoverAnimation.NO_EFFECT) {
    return /*#__PURE__*/React.createElement(WixProGallery, props);
  }
  const animationClass = animationType.toLowerCase().replaceAll('_', '-');
  return /*#__PURE__*/React.createElement("div", {
    className: "pro-gallery-overlay-animation-wrapper " + animationClass
  }, /*#__PURE__*/React.createElement(WixProGallery, props));
};
//# sourceMappingURL=withStylableOverlayAnimations.js.map